import React from 'react';
import '../../style/scss/App.scss';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

function JobPackageSelectionListItem(props) {
   const onClick = (e) => {
      if (props.onChange)
         props.onChange(props.id);
      if (props.onClick)
         props.onClick(props.id);
   }
   return (
      <div className={"jobPackage selectionPanel checkRow" + (props.selected ? ' selected' : '')} id={props.id} onClick={onClick}>
         <span className='icon'>
            <MdCheckBoxOutlineBlank size={1} color="#0075FF" className={props.selected ? 'hidden' : ''} />
            <MdOutlineCheckBox size={1} color="#0075FF" className={props.selected ? '' : 'hidden'} />
         </span>
         <span className='title'>{props.name}</span>
         <span className='byline'></span>
         <span className='rightText'></span>
      </div>
   );
}

export default JobPackageSelectionListItem;